export default [
    {
        path: 'relatorio-estatistico-paciente',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-estatistico-paciente' */
            '@/views/ambulatorio/relatorio-estatistico-paciente/Index'
        ),
        redirect: 'relatorio-estatistico-paciente/index',
        children: [
            {
                name: 'ambulatorio-relatorio-estatistico-paciente-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-estatistico-paciente' */
                    '@/views/ambulatorio/relatorio-estatistico-paciente/List.vue'
                ),
            },
        ],
    },
]